export default {
    pt: {
        roles: {
            admin: 'Administrador',
            manager: 'Professor',
            monitor: 'Monitor',
            noRole: 'Sem perfil'
        },
        actions: {
            add: 'Adicionar {type}',
            addItem: 'Adicionar',
            addGroup: 'Adicionar um novo grupo',
            alignLeft: 'Alinhar à esquerda',
            alignRight: 'Alinhar à direira',
            centerHorizontal: 'Centralizar horizontalmente',
            alignTop: 'Alinhar com o topo',
            alignBottom: 'Alinhar com parte inferior',
            centerVertical: 'Centralizar verticalmente',
            back: 'Voltar',
            cancel: 'Cancelar',
            changeOption: 'Alterar opção...',
            close: 'Fechar',
            copy: 'Copiar',
            confirm: 'Confirmar',
            choose: 'Escolha',
            chooseOption: 'Escolha uma opção ...',
            chooseOneOrMoreOption: 'Escolha uma ou mais opções',
            clear: 'Limpar',
            clearFilters: 'Limpar filtros',
            create: 'Criar um novo {type}',
            delete: 'Excluir',
            distributeHorizontally: 'Distribuir horizontalmente',
            distributeVertically: 'Distribuir verticalmente',
            download: 'Baixar',
            edit: 'Editar',
            editValue: 'Editar valor...',
            execute: 'Executar',
            export: 'Exportar',
            import: 'Importar',
            moveDown: 'Mover para baixo',
            moveUp: 'Mover para cima',
            new: 'Novo',
            paste: 'Colar',
            removeSelected: 'Remover',
            removeValue: 'Remover valor',
            rename: 'Renomear',
            restart: 'Reiniciar {what}',
            restore: 'Restaurar',
            save: 'Salvar',
            saveAs: 'Salvar como',
            saveAsImage: 'Salvar como imagem',
            search: 'Pesquisar',
            selectImage: 'Selecionar imagem',
            share: 'Compartilhar',
            show: 'Exibir',
            showHistory: 'Exibir histórico',
            showProperties: 'Exibir propriedades',
            showResults: 'Exibir resultados',
			showVariables: 'Exibir variáveis',
            simpleAdd: 'Adicionar',
            stop: 'Parar',
            test: 'Testar',
            toggleTasks: 'Habilitar/desabilitar tarefas',
            update: 'Atualizar',
        },
        assets: {
            APP: 'Aplicação (trilha) | Aplicações (trilhas)',
            DATA_SOURCE: 'Fonte de dados | Fontes de dados',
            DASHBOARD: 'Dashboard | Dashboards',
            DEPLOYMENT: 'Implantação | Implantações',
            JOB: 'Execução | Execuções',
            SYSTEM: 'Sistema | Sistema',
            USER: 'Usuário | Usuários',
            WORKFLOW: 'Fluxo de trabalho | Fluxos de trabalho'
        },
        atmosphere: {
            transparency: 'Explicação de modelos'
        },
        cluster: {
            address: 'Endereço (nome ou IP)',
            authToken: 'Token de autenticação',
            executorMemory: 'Memória dos executores',
            executors: 'Executores (nós de processamento)',
            executorCores: 'Núcleos (total de CPUs) dos executures'
        },
        common: {
            action: 'Ação | Ações',
            address: 'Endereço',
            adminRole: 'Administrador',
            author: 'Autor',
            attention: 'Atenção',
            alreadyHaveAccount: 'Já possui uma conta?',
            attribute: 'Atributo | Atributos',
            basicInformation: 'Informação básica',
            category: 'Categoria | Categorias',
            changePassword: 'Criar nova Senha',
            class: 'Classe|Classes',
            column: 'Coluna | Colunas',
            command: 'Comando SQL',
            confirmed_at: 'Confirmado em',
            confirm: 'Confirmar',
            confirmPassword: 'Confirmar senha',
            created: 'Criado',
            createAccount: 'Criar conta',
            current_password: 'Senha Atual',
            date: 'Data',
            description: 'Descrição',
            dontHaveAccount: 'Não possui uma conta?',
            email: 'E-mail',
            enabled: 'Habilitado',
            false: 'Falso',
            filter: 'Filtro|Filtros',
            filterPlaceholder: 'Busca',
            firstName: 'Nome',
            forgotPassword: 'Esqueceu a senha?',
            format: 'Formato',
            height: 'Altura | Alturas',
            help: 'Ajuda',
            hide: 'Ocultar',
            history: 'Histórico',
            id: 'Id',
            image: 'Imagem | Imagens',
            input: 'Entrada | Entradas',
            json: 'JSON (pode ser importado)',
            jupyter: 'Jupyter Notebook',
            label: 'Título',
            language: 'Idioma',
            lastName: 'Sobrenome',
            limit: 'Limite',
            loading: 'Carregando',
            login: 'Entrar',
            logout: 'Sair',
            makeAdmin: 'Tornar Administrador',
            managerRole: 'Gestor',
            monitorRole: 'Monitor',
            more: 'Mais',
            moreRecords: 'Mais registros',
            no: 'Não',
            noData: 'Nenhum registro encontrado.',
            name: 'Nome | Nomes',
            noResults: 'Nenhum resultado',
            nullable: 'Aceita nulos',
            ok: 'OK',
            operation: 'Operação | Operações',
            optional: 'Opcional',
            owner: 'Proprietário',
            pagerShowing:
                'Exibindo registros de {from} até {to}, para um total de {count} registros|{count} registros|Um registro',
            parameters: 'Parâmetro | Parâmetros',
            password: 'Senha',
            path: 'Caminho|Caminhos',
            plugin: 'Plugin',
            project: {
                category: 'Categoria',
                description: 'Descrição',
                managers: 'Responsáveis',
                name: 'Nome',
                subcategory: 'Categoria Secundária',
            },
            python: 'Código Python',
            team: {
                description: 'Descrição',
                leaders: 'Líders',
                name: 'Nome',
            },
            new_password: 'Nova senha',
            new_password_confirmation: 'Confirmação de nova senha',
            permission: 'Permissão | Permissões',
            platform: 'Plataforma',
            precision: 'Precisão',
            preview: 'Pré-visualização',
            rememberMe: 'Lembrar minha senha',
            resetPassword: 'Redefinir',
            roles: 'Perfil | Perfis',
            row: 'Linha | Linhas',
            saveBeforeToEnableThis: 'Salve os dados para habilitar a ação {what}',
            scale: 'Escala',
            sharing: 'Compartilhamento',
            show: 'Exibir',
            size: 'Tamanho',
            slug: 'Slug',
            status: 'Status',
            system: 'Sistema',
            tag: 'Tag | Tags',
            tags: 'Tags',
            text: 'Texto',
            title: 'Título',
            true: 'Verdadeiro',
            type: 'Tipo | Tipos',
            updated: 'Atualizado',
            url: 'URL',
            userId: 'Id de usuário',
            userLogin: 'Login do usuário',
            userName: 'Nome do usuário',
            userRole: 'Usuário',
            user: {
                apiToken: 'Token de API',
                apiTokenWarning: 'Esta ação poderá interromper o funcionando de aplicações. Continuar?',
                authenticationType: 'Tipo de autenticação',
                authenticationInternal: 'Interna',
                authenticationLdap: 'LDAP',
                authenticationAd: 'AD',
                full_name: 'Nome',
                globalRoles: 'Grupos globais (todo usuário faz parte)',
                name: 'Nome do usuário',
                login: 'Login do usuário',
                notes: 'Nota | Notas',
                
            },
            version: 'Versão',
            wait: 'Por favor, aguarde...',
            width: 'Largura | Larguras',
            yes: 'Sim'
        },
        dataTypes: {
            BINARY: 'Verdadeiro ou falso',
            BOOLEAN: 'Verdadeiro ou falso',
            CHARACTER: 'Texto curto',
            DOUBLE: 'Ponto flutuante com mais precisão',
            DECIMAL: 'Decimal',
            DATE: 'Data',
            DATETIME: 'Data e hora',
            FILE: 'Envio de arquivo',
            FLOAT: 'Ponto flutante com menor precisão',
            INTEGER: 'Inteiro',
            LONG: 'Inteiro longo',
            STATIC_TEXT: 'Texto estático',
            TABLE: 'Tabela de pesquisa',
            TEXT: 'Texto longo',
            TIME: 'Hora',
            TIMESTAMP: 'Timestamp',
            VECTOR: 'Vetor',
        },
        dashboard: {
            public: 'Público',
            publicExplanation: 'Este dashboard pode ser visto por outros sem a solicitação de autenticação.',
            markupVisualization: 'Texto (Markdown)',
        },
        dataSource: {
            alternativeUseDatabase:
                'Recomenda-se esta opção apenas se você está seguro que a conexão ao servidor de banco de dados está corretamente configurada.',
            attribute: 'Atributo | Atributos',
            attributeDelimiter: 'Delimitador de atributos (apenas CSV)',
            basicInformation: 'Informação básica',
            characteristics: 'Características',
            databaseConnectionPreviouslyConfigured:
                'A conexão ao servidor de banco de dados deve ter sido configurada anteriormente por um administrador',
            databaseStorage: 'Armazenamento para a base de dados',
            differentFormatsSupported:
                'Diferentes formatos são suportados (CSV, JSON, XML, TXT)',
            distributedFileSystem: 'Sistema de arquivos distribuído (HDFS)',
            dropFilesHere: 'Arraste e solte arquivos aqui para carregá-los ou',
            encoding: 'Codificação (opcional)',
            features: 'Atributos',
            file: 'Arquivo',
            format: 'Formato',
            hive: 'Hive',
            inconsistentFormat:
                'O formato escolhido é incompatível com o armazenamento escolhido.',
            inferSchema: 'Inferir o esquema',
            inferSuccess: 'Atributos inferidos com sucesso.',
            inferSupported:
                'Lemonade suporta inferir atributos para o formato {what}.',
            isFirstLineHeader: 'Usar a primeira linha como cabeçalho',
            isMultiline: 'Multilinhas (atributo com quebra de linha)',
            lookup: 'Usar como tabela de referência',
            message: 'Mensagem',
            missingRepresentation: 'Representação para dados ausentes',
            noPermissions: 'Nenhuma permissão definida',
            noAttributes: 'Nenhum atributo definido.',
            permission: 'Permissão | Permissões',
            previewExplanation: 'Esta é uma amostra com {amount} registros (max).',
            privacy: 'Privacidade',
            privacyAware: 'Suporta privacidade dos dados',
            progress: 'Progresso',
            public: 'Pública',
            recordDelimiter: 'Delimitador de registro (apenas CSV)',
            relationship: 'Relacionamento | Relacionamentos',
            scalability: 'Escalabilidade',
            selectCommand: 'Comando SQL SELECT',
            selectFromComputer: 'selecionar arquivos em seu computador',
            shareModal: {
                title: 'Compartilhando fonte de dados',
                success: 'Permissão alterada'
            },
            shortcut: 'Criar atalho na edição de fluxo de trabalho',
            someAttributesMayHaveProblem:
                'Um atributo pode estar com problema, por favor, revise-o | Alguns atributos podem estar com problema, por favor, revise-os',
            storage: 'Armazenamento',
            suggestedOption:
                'Se você não sabe qual opção escolher, esta é a opção recomendada.',
            tablesReference: 'Tabelas (apenas referência)',
            textDelimiter: 'Delimitador de texto (apenas CSV)',
            treatAsNull: 'Tratar estes valores como valores nulos (opcional)',
            uploadingLog: 'Registro de envio',
            uploadExplanation:
                'Cada arquivo criará uma nova base de dados com nome igual ao nome do arquivo e demais parâmetros com os valores padrão (você poderá alterá-los posteriormente).',
            
            whatTypeOfDataSourceToAdd:
                'Que tipo de base de dados você quer adicionar?',
            youCanUploadYourFiles:
                'Você pdoe carregar seus próprios arquivos para o servidor',
            youCanUseSQL: 'Você pode usar comandos SELECT SQL para recuperar os dados'
        },
        diagram: {
            showProperties:
                'Para exibir as propriedades de uma tarefa, clique 2x sobre ela.'
        },
        errors: {
            acceptTerms: 'Você deve concordar com os termos de uso',
            accessDenied: 'Acesso negado.',
            badGateway: 'Há um problema na comunicação com o servidor. Por favor, tente mais tarde.',
            disconnected:
                'Você não está conectado. Por favor, verifique se você tem acesso à Internet.',
            emailNotFound: 'Email não cadastrado.',
            invalidDataSource:
                'Pelo menos uma fonte de dados de entrada usada no fluxo de trabalho é inválida, revise a configuração e se você está conectado à internet.',
            invalidLoginOrPassword: 'Senha ou usuário inválidos',
            invalidOperation: 'Operação inválida',
            invalidVisualizationId:
                'Visualização não registrada. Contacte o suporte.',
            missingRequiredValue: 'Valor obrigatório ausente',
            missingRequiredValueOrInvalid: 'Valor obrigatório ausente ou dados inválidos',
            notFound: 'Registro não encontrado',
            pageNotFound: 'Página não encontrada',
            passwordDontMatch: 'Senhas são diferentes',
            passwordTooShort: 'Senha deve ter mais que 5 caracteres',
            loginInUse: 'Login/email estão em uso por outro usuário. Tente outro.',
            receivingData: 'Erro recebendo dados do servidor.',
            resetPasswordTokenThisRequetHasExpiredPleaseMakeAnotherRequest:
                'Este link expirou, por favor redefina sua senha novamente.',
            sendingData: 'Erro enviando dados do servidor.',
            validation: 'Erro(s) de validação',
            validationExplanation: 'Por favor, corrija o(s) erro(s) e tente novamente.',
        },
        warnings: {
            dirtyCheck:
                'Existem alterações que ainda não foram salvas. Deseja sair assim mesmo?'
        },
        import: {
            description: 'Importe um arquivo com a definição do fluxo de trabalho.' +
                'O arquivo deve estar no formato correto e ser compatível com a versão do Lemonade. ',
            review: 'Após a importação, certifique-se de atualizar as fontes de dados, pois elas NÃO são importadas ' +
                'junto com o fluxo de trabalho.',
            selectFile: 'Por favor, selecione um arquivo.'
        },
        job: {
            details: 'Detalhe | Detalhes',
            error:
                'Erro durante a execução. Veja mais detalhes na janela de log acima.',
            logs: 'Log | Logs',
            parameters: 'Parâmetro | Parâmetros',
            results: 'Resultado | Resultados',
            sourceCode: 'Código-fonte',
            values: 'Valor | Valores',
            visualizations: 'Visualização | Visualizações'
        },
        juicer: {
            log: {
                error: 'ERRO',
                info: 'INFORMAÇÂO',
                warn: 'AVISO',
                warning: 'AVISO'
            }
        },
        messages: {
            acceptTerms: 'Concordo com os <a href="{link}">termos de uso</a>.',
            doYouWantToDelete: 'Tem certeza que você quer excluir esse registro?',
            doYouWantToConfirm: 'Tem certeza que você quer confirmar esse usuário?',
            doYouWantToStop: 'Tem certeza que quer parar esta execução? Os dados armazenados na memória serão descartados e os recursos da infraestrutura serão liberados.',
            confirmRemove: 'Tem certeza que você quer excluir esse registro?',
            exportWorkflow: 'Fluxo de trabalho exportado usando a versão atual.',
            successDeletion: '{what} foi removido com sucesso',
            successStop: 'Execução parada com sucesso',
            successImport: 'Fluxo de trabalho foi importado com o id={what}.',
            resetPasswordInstructions: '<p>Um e-mail foi enviado para seu endereço. Siga as instruções para redefinir sua senha.</p>' +
                '<p>Se você não receber esse e-mail, ' +
                'verifique suas pastas de spam ou de lixo eletrônico e também ' +
                'adicione o endereço <strong>{email}</strong> ao seu catálogo de endereços. Você pode tentar redefinir sua senha a qualquer momento.</p>',
            registeredWithSuccess:
                'Você foi registrado com sucesso. Por favor, autentique-se novamente.',
            savedWithSuccess: '{what} foi salvo(a) com sucesso!',
            noMatching: 'Lamentamos, nenhuma opção encontrada',
            notesDescription: 'Essa descrição opcional é usada pelos administradores para aprovar novos usuários.',
            usingDisabledOperation:
                'O fluxo de trabalho usa operações que não estão mais habilitadas no Lemonade. A execução não funcionará. Remova ou substitua as tarefas associadas a essas operações antes de executar o fluxo.',
            welcome: '<p>A autorização para uso do Lemonade está depende da análise do seu registro por um administrador. </p>' +
                '<p>Uma notificação já foi enviada para os administradores e em breve você receberá um e-email com a confirmação de seu registro.</p>' +
                'Enquanto isto, você pode iniciar a leitura da documentação disponível em <a href="http://docs.lemonade.org.br">http://docs.lemonade.org.br</a>.',
            tokenNotFound: 'Token para reiniciar senha não foi encontrado. Tente iniciar o processo novamente ou veja se você recebeu um novo link em outro e-mail.',
            validatingToken: 'Validando o token, por favor, aguarde...',
        },
        model: {
            uploadExplanation:
                'Cada arquivo criará um novo model com nome igual ao nome do arquivo e tipo conforme selecionado anteriormente.',

            selectFromComputer: 'selecionar arquivos em seu computador',
            dropFilesHere: 'Arraste e solte os arquivos aqui',
            whatTypeOfModelToAdd: 'Que tipo de modelo você quer adicionar?',

            storage: 'Armazenamento | Armazenamentos',
            type_KERAS: 'Keras',
            type_PERFORMANCE_SPARK: 'Desempenho (Spark)',
            type_PERFORMANCE_KERAS: 'Desempenho (Keras)',
            type_SPARK_ML_CLASSIFICATION: 'Classificação (Spark)',
            type_SPARK_ML_REGRESSION: 'Regressão (Spark)',
            type_SPARK_MLLIB_CLASSIFICATION: 'Classificação (MLLib)',
            type_UNSPECIFIED: 'Não especificado',

        },
        platform: {
            allOperations: 'Todas as operações',
            gitUrl: 'URL para clonar o repositório Git',
            pluginDetailExplanation: 'Esta plataforma é um plugin. Ela foi instalada a partir de um código fonte de fora do Lemonade ' +
                'e é usada como uma extensão.',
            pluginExplanation: `<p>Apenas platformas definidas como plugins podem ser adicionadas ao sistema.
                Você precisa criar um repositório Git acessível por este servidor, opcionalmente fornecendo
                todos os detalhes de autenticação necessários.</p>
                <p>Plugins podem conter códigos maliciosos que poderão danificar o sistema, usar recursos para fins ilícitos 
                ou roubar informações importantes. <strong>Certifique-se de importar plugins somente de fontes confiáveis</strong>.
                Esta ação poderá demorar alguns minutos para terminar.
                </p>
                <p>
                Para mais detalhes sobre a estrutura de código necessária e os passos para definir um plugin, visite: 
                <a href="https://github.com/dccspeed/demo-plugin">https://github.com/dccspeed/demo-plugin</a>.</p>
            `,
            subset: 'Subconjunto de operações | Subconjuntos de operações',
        },
        notebook: {
            executeUntil: 'Executar até esta célula',
            delete: 'Excluir célula',
            moveDown: 'Mover para baixo',
            moveUp: 'Mover para cima',
            newCell: 'Nova célula',
            input: 'Entrada | Entradas'
        },
        privacy: {
            anonymizationTechnique: 'Técnica de anonimização',
            privacyType: 'Tipo de privacidade',
            hierarchy: 'Hierarquia (apenas se tipo de anonimização = GENERALIZATION)',
            attributePrivacyGroup: 'Grupo de atributos para privacidade'
        },
        profile: {
            alsoChangePassword: 'Também altere minha senha',
            updated: 'Perfil atualizado'
        },
        property: {
            alias: 'Nome novo',
            attribute: 'Atributo',
            availableAttribute: 'Atributo disponível | Atributos disponíveis',
            clickToMove: 'Clique um item para movê-lo entre as listas',
            copyAttributeName: 'Duplo clique para copiar e colar na caixa de edição',
            editValue: 'Editar valor ...',
            expression: {
                availableAttribute: 'Atributo disponível | Atributos disponíveis',
                alias: 'Nome (alias)',
                explanation:
                    'Adicione uma ou mais expressões. Novos atributos serão criados para as expressões informadas aqui, portanto, é necessário informar um nome (alias) para eles.',
                tip: `Para usar um atributo existente, basta informar seu nome. Para constantes do tipo texto (string), delimite-as com aspas ou apóstrofos (' ou ").
                Exemplos: <strong><code>substring(atributo, instr(atributo, " "))</code><strong>.`,
                title: 'Expressão',
                validExpressions: `Expressões válidas incluem expressões matemáticas
                (ex. <strong><code>atributo * 10 - 4 </code></strong>) e chamadas a funções
                (ex. <strong><code>split(atributo, ' ')</code></strong>). Para mais informações,
                consulte o Guia de referência do Lemonade ou as funções existentes na plataforma Apache Spark. `
            },
            function: 'Função',
            help: 'Ajuda',
            informAttributeName: 'Não está na lista? Informe um nome',
            noExpressions: 'Nenhuma expressão',
            queryBuilder: {
                explanation:
                    'Escreva uma consulta SQL válida. A sintaxe suportada depende da plataforma escolhida. Geralmente, consultas simpels funcionam na maioria dos casos. Veja a documentação do Lemonade para mais exemplos.',
                title: 'Consulta SQL'
            },
            selectedAttribute: 'Atributo selecionado | Atributos selecionados',
            taskName: 'Nome da tarefa (opcional)'
        },
        titles: {
            about: 'Sobre',
            action: 'Ação | Ações',
            actualValue: 'Valor atual',
            administration: 'Administração',
            apiToken: 'Tokens para API',
            app: 'Aplicação (trilha) | Aplicações (trilhas)',
            allNotifications: 'Ver todas as notificações',
            changePassword: 'Nova senha',
            color: 'Color',
            cluster: 'Cluster | Clusters',
            configuration: 'Configuração | Configurações',
            darkMode: 'Modo escuro',
            dataSource: 'Fonte de dados | Fontes de dados',
            dataSource2: 'Fonte de dados | Fontes de dados',
            dashboard: 'Dashboard | Dashboards',
            deployment: 'Implantação | Implantações',
            documentation: 'Documentação',
            error: 'Erro',
            errorDetail: 'Detalhe do erro (avançado)',
            globalPrivacyPolicy:
                'Política global de privacidade|Políticas globais de privacidade',
            home: 'Bem-vindo ao Lemonade',
            info: 'Info | Informação',
            job: 'Execução | Execuções',
            jobs: 'Execuções',
            lemonade: 'Lemonade',
            lemonadePlatform: 'Plataforma Lemonade',
            login: 'Entrar',
            model: 'Modelo | Modelos',
            news: 'Novidades e Dicas',
            notebook: 'Notebook | Notebooks',
            notification: 'Notificação | Notificações',
            pageNotFound: 'Página não encontrada',
            operation: 'Operação | Operações',
            platform: 'Platforma | Platformas',
            profile: 'Perfil',
            project: 'Projeto | Projetos',
            team: 'Time | Times',
            property: 'Propriedade | Propriedades',
            publication: 'Publicação | Publicações',
            register: 'Registrar',
            resetPassword: 'Redefinir senha',
            role: 'Grupo | Grupos',
            storage: 'Armazenamento | Armazenamentos',
            success: 'Sucesso',
            systemVariables: 'Variável de sistema | Variáveis de sistema',
            tasks: 'Tarefa | Tarefas',
            template: 'Modelo | Modelos',
            toolboxCategory: 'Organização das operações',
            tool: 'Ferramenta | Ferramentas',
            track: 'Trilha | Trilhas',
            undefined: 'Não definido',
            user: 'Usuário | Usuários',
            validationErrors: 'Erro de validação | Erros de validação',
            value: 'Valor',
            visualization: 'Visualização | Visualizações',
            warning: 'Aviso',
            welcome: 'Bem-vindo(a) ao Lemonade!',
            whatIfModel: 'What if model?',
            workflow: 'Fluxo de trabalho | Fluxos de trabalho'
        },
        track: {
            status: 'Status',
            whichTrack: 'Qual trilha você está procurando?',
            EDITING: 'Em edição',
            PUBLISHED: 'Publicado',
            DISABLED: 'Desabilitado',
        },

        home: {
            aPlatformForDataScience: 'Uma plataforma para ciência dos dados',
            learnMore: 'Aprenda mais',
            recentlyUpdated: 'Atualizados recentemente',
            welcome: `Bem-vindo ao Lemonade.
            Lemonade (Live Exploration and Mining Of Non-trivial Amount of Data from Everywhere) é uma platforma visual para computação distribuída
            que permite a implementação, experimentação, teste and implantação de aplicações de processamento de dados aprendizado de máquina.
            Ele provê um nível mais alto de abstração (fluxo de trabalho e operations) para que os usuários construam aplicações em uma interface gráfica web.
            Por usar tecnologias escaláveis e de alto desempenho, tais como COMPSs, Keras+Tensorflow e Spark,
            Lemonade pode processar grandes volumes de dados, ocultado toda a complexidade de infraestrutura dos usuários, permitindo-os focar
            principalmente na construção da solução.
            Lemonade é implementado como uma ferramenta de código aberto e está em desenvolvimento
            como produto dos projetos EUBra-BIGSEA e Atmosphere.`
        },
        visualization: {
            lowerQuartile: 'Quartil inferior (1o)',
            maximum: 'Máximo',
            median: 'Mediana',
            minimum: 'Mínimo',
            ofEntry: 'do total visível',
            ofParent: 'do total do pai',
            outlier: 'Discrepante | Discrepantes',
            tryRefresh:
                'Tente atualizar a página, pode ser que a visualização ainda esteja sendo carregada',
            upperQuartile: 'Quartil superior (3o)',
        },
        workflow: {
            asImage: 'Como uma imagem (uma janela para baixar a imagem aparecerá)',
            asTemplate:
                'Como um modelo de fluxo de trabalho (poderá ser reusado posteriormente)',
            copyOf: 'Cópia de',
            copySavedWithSuccess: 'Cópia salva com sucesso!',
            execute: 'Executar fluxo de trabalho',
            errorNoCluster: 'Não há recursos computacionais (clusters) configurados para executar o fluxo de trabalho. Contacte o administrador.',
            forPlatform: 'Para uma plataforma de processamento',
            fromTemplate: 'A partir de um modelo',
            fromUserTemplate: 'A partir de um modelo criado por usuários',
            imageGeneratedAt: 'Imagem gerada em',
            jobName: 'Nome para a execução',
            newName:
                'Novo nome (uma cópia do fluxo de trabalho será criado, mas não será carregado)',
            noTasks: 'Nenhuma tarefa adicionada ao fluxo. Use a opção "Adicionar Operação" acima para iniciar a construção do fluxo.',
            preferredCluster: 'Cluster preferencial para execução',
            publishingEnabled: 'Habilitar publicação do fluxo de trabalho',
            publishingEnabledExplanation: 'Permite que o fluxo de trabalho seja publicado para os usuários.',
            publishingSelect: 'Selecione as propriedades que podem ser alteradas pelos usuários para fluxos de trabalho publicados.',
            publishingStatus: 'Status da publicação',
            publisingStatusEditing: 'Em edição - Não está disponível para os usuários',
            publisingStatusPublished: 'Publicado - Disponível para os usuários',
            required:
                'Por favor, complete as informações necessárias para a execução do fluxo de trabalho',
            restoreHistory:
                'Você quer realmente restaurar o fluxo de trabalho para uma versão antiga?',
            versionRestored:
                'Versão {version} restaurada com sucesso.',
			setImage: 'Definir imagem para o workflow',
            useAsTemplate: 'Disponibilizar este fluxo de trabalho como modelo',
            useAsTemplateExplanation:
                'Você poderá criar outros fluxos de trabalho a partir deste. Na tela de novo fluxo de trabalho, escolha a opção "A partir de um modelo".',

            useAsSystemTemplate: 'Disponibilizar este fluxo de trabalho como modelo para todos os usuários',
            useAsSystemTemplateExplanation:
                'Qualquer usuário poderá criar outros fluxos de trabalho a partir deste. Na tela de novo fluxo de trabalho, escolha a opção "A partir de um modelo".',
            usingDisabledOperation: 'Tarefa usa operação desabilitada no Lemonade',
            validationExplanation:
                'Há um erro no fluxo de trabalho. A execução poderá não ter sucesso. | Existem erros no fluxo de trabalho. A execução poderá não ter sucesso.',
            variables: 'Variável | Variáveis',
        },
        variables: {
            addOrEdit: 'Adicione um ou mais itens <br /> ou clique um dos filtros à direita para editá-lo.',
            attribute: 'Atributo',
            associateTo: 'Associar a variável',
            associateToLookup: 'Associar a tabela de referência',
            defaultValue: 'Valor-padrão',
            description: 'Descrição',
            help: 'Ajuda',
            id: 'Identificador',
            index: 'Índice para exibição',
            label: 'Rótulo',
            multiplicity: 'Multiplicidade',
            name: 'Nome',
            names: {
                date: 'Data atual',
                date_at_min: 'Data atual com hora 00:00:00',
                date_at_max: 'Data atual com hora 23:59:59',
                now: 'Data e hora atuais',
                user_id: 'Identificador do usuário',
                user_login: 'Login de usuário',
                user_name: 'Nome completo do usuário',
                workflow_id: 'Identificador do fluxo de trabalho',
                workflow_name: 'Nome do fluxo de trabalho',
            },
            operator: 'Operador | Operadores',
            parameter: 'Parâmetro | Parâmetros',
            suggestedWidget: 'Campo sugerido',
            text: 'Texto|Textos',
            textAfter: 'Texto após do campo (suporta Markdown)',
            textBefore: 'Texto antes o campo (suporta Markdown)',
            type: 'Tipo',
            values: 'Valor | Valores',
            operators: {
                bt: 'Entre faixas',
                eq: 'Igual (=)',
                lt: 'Menor que (<)',
                gt: 'Maior que (>)',
                le: 'Menor ou igual (<=)',
                ge: 'Maior ou igual (>=)',
                ne: 'Diferente (/=)',
                'in': 'Está na lista (∈)',
                ni: 'Não está na lista (∉)',
                user: 'Escolhido pelo usuário',
            }
        },
        widgets: {
            checkbox: 'Caixa de seleção/check',
            date: 'Seleção de data',
            decimal: 'Número com decimais',
            dropdown: 'Caixa de seleção',
            integer: 'Número',
            lookup: 'Valores pesquisáveis',
            text: 'Texto curto',
            textarea: 'Texto longo',
            join: {
                allAttributesWithPrefix: 'Todos os atributos prefixados',
                conditions: 'Condição(ões) para a junção',
                nameCollision: 'As entradas têm atributos com o mesmo nome. Isto pode causar problemas se você não usar um prefixo ou renomear os atributos.',
                noCondition: 'Nenhuma condição informada. Pressione o botão abaixo para adicionar uma nova.',
                noAttributes: 'Nenhum atributo',
                selectAttributes: 'Selecionar atributos',
                type: 'Tipo de Junção',
            },
            expressionEditor:{
                atPosition: 'na posição',
                expected: 'Esperado',
                expectedColon: 'Esperado :',
                expectedExpression: 'Esperada expressão',
                expectedExpressionAfter: 'Esperada expressão após',
                expectedExponent: 'Expoente esperado',
                variableNamesWithNumber: 'Nomes de variáveis não podem começar com um dígito',
                unexpected: 'Caracter(es) inesperado(s)',
                unexpectedComma: 'Vírgula não era esperada',
                unexpectedPeriod: 'Ponto-final não era esperado',
                unexpectedToken: 'Token não era esperado',
                unexpectedQuote: 'Aspas não eram esperadas',
                unclosedQuoteAfter: 'Aspas não foram fechadas',
                unclosedBrace: '[ não foi fechado',
                unclosedParenthesis: '( não foi fechado',
                unsupportedCompounded: 'Expressão não-suportada',
            },
            
        },

        permissions: {
            MANAGE: 'Gerenciar',
            READ: 'Ler',
            WRITE: 'Escrever',
            descriptions: {
                MANAGE: 'Permite todas as ações ao item',
                READ: 'Permite ler o item',
                WRITE: 'Permite alterar ou excluir o item',
            }
        },
        storage: {
            address1: 'URL principal',
            address2: 'URL secundária',
            extraParameters: 'Parâmetros extras',
        },
    },

    en: {
        roles: {
            admin: 'Administrator',
            manager: 'Teacher',
            monitor: 'Monitor',
            noRole: 'Without Role'
        },
        actions: {
            add: 'Add new {type}',
            addItem: 'Add',
            addGroup: 'Add a new group',
            alignLeft: 'Align left',
            alignRight: 'Align right',
            alignTop: 'Align top',
            alignBottom: 'Align bottom',
            back: 'Back',
            cancel: 'Cancel',
            changeOption: 'Change option...',
            choose: 'Choose',
            chooseOption: 'Choose option...',
            chooseOneOrMoreOption: 'Choose one or more options',
            close: 'Close',
            confirm: 'Confirm',
            copy: 'Copy',
            clear: 'Clear',
            clearFilters: 'Clear filters',
            create: 'Create new {type}',
            delete: 'Delete',
            distributeHorizontally: 'Distribute horizontally',
            distributeVertically: 'Distribute vertically',
            download: 'Download',
            edit: 'Edit',
            editValue: 'Edit value...',
            execute: 'Execute',
            export: 'Export',
            import: 'Import',
            moveDown: 'Move down',
            moveUp: 'Move up',
            new: 'New',
            paste: 'Paste',
            removeSelected: 'Remove',
            removeValue: 'Remove value',
            rename: 'Rename',
            restart: 'Restart',
            restore: 'Restore',
            save: 'Save',
            saveAs: 'Save as',
            saveAsImage: 'Save as image',
            search: 'Search',
            selectImage: 'Select image',
            share: 'Share',
            show: 'Show',
            showHistory: 'Show history',
            showProperties: 'Show properties',
            showResults: 'Show results',
			showVariables: 'Show variables',
            simpleAdd: 'Add',
            stop: 'Stop',
            test: 'Test',
            toggleTasks: 'Enable/disable tasks',
            update: 'Update',
        },
        assets: {
            APP: 'Application | Applications',
            DATA_SOURCE: 'Data source | Data Sources',
            DASHBOARD: 'Dashboard | Dashboards',
            DEPLOYMENT: 'Deployment | Deployments',
            JOB: 'Execution | Executions',
            SYSTEM: 'System | System',
            USER: 'User | Users',
            WORKFLOW: 'Workflow | Workflows'
        },
        atmosphere: {
            transparency: 'Explain models'
        },
        cluster: {
            address: 'Address (hostname or IP)',
            authToken: 'Authentication token',
            executorMemory: "Executors' memory",
            executors: 'Number of executors',
            executorCores: 'Cores (CPUs) for executors'
        },
        common: {
            makeAdmin: 'Make Administrator',
            action: 'Action | Actions',
            address: 'Address',
            adminRole: 'Administrator',
            author: 'Author',
            attention: 'Attention',
            alreadyHaveAccount: 'Already have an account?',
            attribute: 'Attribute | Attributes',
            basicInformation: 'Basic Information',
            category: 'Category | Categories',
            changePassword: 'Create new password',
            class: 'Class|Classes',
            column: 'Column | Columns',
            command: 'SQL Command',
            confirm: 'Confirm',
            confirmed_at: 'Confirmed at',
            confirmPassword: 'Confirm password',
            created: 'Created',
            createAccount: 'Sign up',
            date: 'Date',
            description: 'Description',
            dontHaveAccount: "Don't have an account?",
            email: 'E-mail',
            enabled: 'Enabled',
            false: 'False',
            filter: 'Filter',
            filterPlaceholder: 'Search',
            firstName: 'First name',
            forgotPassword: 'Forgot password?',
            format: 'Format',
            heigh: 'Height | Heights',
            help: 'Help',
            hide: 'Hide',
            history: 'History',
            id: 'Id',
            image: 'Image | Images',
            input: 'Input | Inputs',
            json: 'JSON (can be imported)',
            jupyter: 'Jupyter Notebook',
            label: 'Label',
            language: 'Language',
            lastName: 'Last name',
            limit: 'Limit',
            loading: 'Loading',
            login: 'Sign in',
            logout: 'Sign off',
            managerRole: 'Manager',
            monitorRole: 'Assistant',
            more: 'More',
            moreRecors: 'More records',
            no: 'No',
            name: 'Name | Names',
            noData: 'No results found.',
            noResults: 'No results',
            nullable: 'Nullable',
            ok: 'OK',
            operation: 'Operation | Operations',
            optional: 'Optional',
            owner: 'Owner',
            pagerShowing:
                'Showing {from} to {to} of {count} records|{count} records|One record',
            parameters: 'Parameter | Parameters',
            password: 'Password',
            path: 'Path | Paths',
            plugin: 'Plugin',
            project: {
                name: 'Name',
                description: 'Description',
                category: 'Main Category',
                subcategory: 'Sub Category',
                managers: 'Managers'
            },
            python: 'Python code',
            team: {
                name: 'Name',
                description: 'Description',
                leaders: 'Leaders'
            },
            current_password: 'Current password',
            new_password: 'New password',
            new_password_confirmation: 'New password confirmation',
            permission: 'Permission | Permissions',
            platform: 'Platform',
            precision: 'Precision',
            preview: 'Preview',
            rememberMe: 'Remember me',
            resetPassword: 'Reset',
            roles: 'Role | Roles',
            row: 'Row | Rows',
            saveBeforeToEnableThis: 'Save data to enabled the {what} action',
            scale: 'Scale',
            sharing: 'Sharing',
            show: 'Show',
            size: 'Size',
            slug: 'Slug',
            status: 'Status',
            system: 'System',
            tag: 'Tag | Tags',
            tags: 'Tags',
            text: 'Text',
            title: 'Title',
            true: 'True',
            type: 'Type | Types',
            updated: 'Updated',
            url: 'URL',
            userId: 'User id',
            userLogin: 'User login',
            userName: 'User name',
            userRole: 'User',
            user: {
                apiToken: 'API token',
                apiTokenWarning: 'This action may break existing applications. Continue?',
                authenticationType: 'Authentication type',
                authenticationInternal: 'Internal',
                authenticationLdap: 'LDAP',
                authenticationAd: 'AD',
                full_name: 'Name',
                globalRoles: 'Global groups (all users are members of)',
                name: 'User name',
                login: 'User login',
                notes: 'Note | Notes',
            },
            version: 'Version',
            wait: 'Please, wait...',
            width: 'Width | Widths',
            yes: 'Yes'
        },
        dataTypes: {
            BINARY: 'True or false',
            BOOLEAN: 'True or false',
            CHARACTER: 'Short text',
            DOUBLE: 'Float with double precision',
            DECIMAL: 'Decimal',
            DATE: 'Date',
            DATETIME: 'Date and hour',
            FILE: 'File upload',
            FLOAT: 'Float',
            INTEGER: 'Integer',
            LONG: 'Long integer',
            STATIC_TEXT: 'Static text',
            TABLE: 'Lookup table',
            TEXT: 'Long text',
            TIME: 'Time',
            TIMESTAMP: 'Timestamp',
            VECTOR: 'Vector',
        },
        dashboard: {
            public: 'Public',
            publicExplanation: 'This dashboard can be viewed by other people without requiring authentication.',
            markupVisualization: 'Text (Markdown)',
        },
        dataSource: {
            alternativeUseDatabase:
                'We recommend this option only if you are sure the database connection is correctly configured.',
            attribute: 'Attribute | Attributes',
            attributeDelimiter: 'Attribute delimiter (CSV only)',
            basicInformation: 'Basic information',
            characteristics: 'Characteristics',
            databaseConnectionPreviouslyConfigured:
                'The database connection must be previously configured by an administrator',
            databaseStorage: 'Database storage',
            differentFormatsSupported:
                'Different formats are supported (CSV, JSON, XML, TXT)',
            distributedFileSystem: 'Distributed file system (HDFS)',
            dropFilesHere: 'Drop files here to upload or',
            encoding: 'Encoding (optional)',
            features: 'Features',
            file: 'File',
            format: 'Format',
            hive: 'Hive',
            inconsistentFormat:
                'The chosen format is incompatible with the chosen storage.',
            inferSchema: 'Infer schema',
            inferSuccess: 'Attributes infered with success.',
            inferSupported:
                'Lemonade supports infering attributes for the format {what}.',
            isFirstLineHeader: 'Use first line as header',
            isMultiline: 'Is multiline',
            lookup: 'Only use as reference table',
            message: 'Message',
            missingRepresentation: 'Missing representation',
            noPermissions: 'No permissions defined',
            noAttributes: 'No attributes defined.',
            permission: 'Permission | Permissions',
            previewExplanation: 'This is a sample of {amount} rows (max).',
            privacy: 'Privacy',
            privacyAware: 'Privacy aware',
            progress: 'Progress',
            public: 'Public',
            relationship: 'Relationship | Relationships',
            recordDelimiter: 'Record delimiter (CSV only)',
            scalability: 'Scalability',
            selectCommand: 'SQL SELECT command',
            selectFromComputer: 'select them from your computer',
            shareModal: {
                title: 'Sharing Data Source',
                success: 'Permissions changed'
            },
            shortcut: 'Create a shortcut in workflow editing',
            someAttributesMayHaveProblem:
                'An attribute may be incorrectly configured, please, check it | Some attributes may be incorrectly configured, please, check them',
            storage: 'Storage',
            suggestedOption:
                'If you do not know what to choose, this is the suggested option.',
            tablesReference: 'Tables (only for reference)',
            textDelimiter: 'Text delimiter (CSV only)',
            treatAsNull: 'Treat these values as null (optional)',
            uploadingLog: 'Uploading log',
            uploadExplanation:
                'Each file will create a new data source with name equals to the file and other parameters with default values (you will be able to change them later).',
            whatTypeOfDataSourceToAdd: 'What type of data source do you want to add?',
            youCanUploadYourFiles: 'You can upload your own files',
            youCanUseSQL: 'You can use SQL to query data'
        },
        diagram: {
            showProperties: 'Tip: Double click a task to show its properties'
        },
        errors: {
            acceptTerms: 'You must accept the terms of service',
            accessDenied: 'Access denied.',
            badGateway: 'There is a problem connecting to the server. Please, try again later.',
            disconnected:
                'You are disconnected. Please check if you have access to the Internet.',
            emailNotFound: 'Email not found.',
            invalidDataSource: 'At least one data source is invalid in workflow',
            invalidLoginOrPassword: 'Invalid login or password',
            invalidOperation: 'Invalid operation',
            invalidVisualizationId:
                'Invalid visualization. Please, contact the support.',
            missingRequiredValue: 'Missing required value',
            missingRequiredValueOrInvalid: 'Missing required value or invalid data',
            notFound: 'Record not found',
            pageNotFound: 'Page not found',
            passwordDontMatch: 'Passwords do not match',
            passwordTooShort: 'Passwords must have more than que 5 characters',
            loginInUse: 'Login/email is in use. Try another one.',
            receivingData: 'Error receiving data from the server',
            resetPasswordTokenThisRequetHasExpiredPleaseMakeAnotherRequest:
                'This requet has expired. Please make another request.',
            sendingData: 'Error sending data to the server.',
            validation: 'Validation error(s)',
            validationExplanation: 'Please, fix the error(s) and try again.',
        },
        warnings: {
            dirtyCheck:
                'This workflow has modifications that has not been saved. Do you want to leave anyway?'
        },
        messages: {
            acceptTerms: 'I agree to the <a href="{link}">terms of service</a>.',
            doYouWantToDelete: 'Do you want to delete this record?',
            doYouWantToConfirm: 'Do you want to confirm this user?',
            doYouWantToStop: 'Do you want to stop the execution? Data stored in memory will be discarded and infrastructure resources will be released.',
            exportWorkflow: 'Workflow exported using current version.',
            confirmRemove: 'Are you sure you want to remove this record?',
            successDeletion: '{what} was successfuly removed',
            successStop: 'Execution successfully stopped',
            successImport: 'Workflow was imported as id={what}.',
            registeredWithSuccess:
                'You were registered with success. Please, sign in again.',
            resetPasswordInstructions: '<p>An email has been sent to your address. Follow the instructions to reset your password.</p>' +
                '<p>If you do not receive this email, check your spam or junk folders and also ' +
                'add <strong>{email}</strong> to your address book. You can try to reset your password at any time.',
            savedWithSuccess: '{what} saved with success.',
            noMatching: 'Sorry, no matching options',
            notesDescription: 'This optional description is used by administrators to approve new users.',
            usingDisabledOperation:
                'The workflow uses some operations not avaialable in Lemonade anymore. Workflow will not run. Remove or replace tasks associated to those operations before running the flow.',
            welcome: '<p>Approval for use of Lemonade depends on an administrator reviewing your registration.</p>' +
                '<p>A notification has already been sent to administrators and you will soon receive an email with confirmation of your registration.</p>' +
                '<p>In the meantime, you can start reading the documentation available at <a href="http://docs.lemonade.org.br">http://docs.lemonade.org.br</a>.',
            tokenNotFound: 'Reset password token not found. Try to do the reset password action and check if you received another email with a new link.',
            validatingToken: 'Validating token, please wait...',
        },
        notebook: {
            delete: 'Delete cell',
            executeUntil: 'Execute until this cell',
            input: 'Input | Inputs',
            moveDown: 'Move down',
            moveUp: 'Move up',
            newCell: 'New cell',
        },
        import: {
            description: 'You may import a file containing a workflow definition. ' +
                'Imported file must be in the correct format and be compatible with Lemonade version. ',
            review: 'After importing, be sure to update the data sources because they are NOT imported ' +
                'with the workflow.',
            selectFile: 'Please, select a file'
        },
        job: {
            details: 'Detail | Details',
            error: 'Error running job. See more details in the log window above.',
            logs: 'Log | Logs',
            parameters: 'Parameter | Parameters',
            results: 'Result | Results',
            sourceCode: 'Source code',
            values: 'Value | Values',
            visualizations: 'Visualization | Visualizations'
        },
        juicer: {
            log: {
                info: 'INFO',
                warning: 'WARN',
                error: 'ERROR',
                warn: 'WARN'
            }
        },
        titles: {
            about: 'About',
            action: 'Action | Actions',
            actualValue: 'Current value',
            administration: 'Administration',
            apiToken: 'API Tokens',
            app: 'App | Apps',
            allNotifications: 'See all notifications',
            changePassword: 'New password',
            cluster: 'Cluster | Clusters',
            color: 'Color',
            configuration: 'Configuration | Configurations',
            darkMode: 'Dark mode',
            dataSource: 'Data source | Data sources',
            dataSource2: 'Data source | Data sources',
            dashboard: 'Dashboard | Dashboards',
            deployment: 'Deployment | Deployments',
            documentation: 'Documentation',
            error: 'Error',
            errorDetail: 'Error detail (advanced)',
            globalPrivacyPolicy: 'Global privacy policy|Global privacy policies',
            home: 'Welcome to Lemonade',
            info: 'Info | Information',
            job: 'Job | Jobs',
            jobs: 'Jobs',
            lemonade: 'Lemonade',
            lemonadePlatform: 'Lemonade Platform',
            model: 'Model | Models',
            news: 'News & Tips',
            notebook: 'Notebook | Notebooks',
            notification: 'Notification | Notifications',
            operation: 'Operation | Operations',
            login: 'Login',
            pageNotFound: 'Page not found',
            platform: 'Platform | Platforms',
            profile: 'Profile',
            project: 'Project | Projects',
            team: 'Team | Teams',
            property: 'Property | Properties',
            publication: 'Publications | Publications',
            register: 'Sign up',
            resetPassword: 'Reset password',
            role: 'Role | Roles',
            storage: 'Storage | Storages',
            success: 'Success',
            systemVariables: 'System variable | System variables',
            tasks: 'Task | Tasks',
            template: 'Template | Templates',
            toolboxCategory: 'Toolbox disposition',
            tool: 'Tool | Tools',
            track: 'Track | Tracks', 
            undefined: 'Not set',
            user: 'User | Users',
            validationErrors: 'Validation error | Validation errors',
            value: 'Value',
            visualization: 'Visualization | Visualizations',
            warning: 'Warning',
            welcome: 'Welcome to Lemonade!',
            whatIfModel: 'What if model?',
            workflow: 'Workflow | Workflows'
        },
        track: {
            status: 'Status',
            whichTrack: 'Which track are you looking for?',
            EDITING: 'Editing',
            PUBLISHED: 'Published',
            DISABLED: 'Disabled',
        },
        model: {
            storage: 'Storage| Storage',
            type_KERAS: 'Keras',
            type_PERFORMANCE_SPARK: 'Performance (Spark)',
            type_PERFORMANCE_KERAS: 'Performance (Keras)',
            type_SPARK_ML_CLASSIFICATION: 'Classification (Spark)',
            type_SPARK_ML_REGRESSION: 'Regression (Spark)',
            type_SPARK_MLLIB_CLASSIFICATION: 'Classification (MLLib)',
            type_UNSPECIFIED: 'Unspecified'
        },
        platform: {
            allOperations: 'All operations',
            gitUrl: 'Git repository URL used to clone the plugin',
            pluginDetailExplanation: 'This platform is a plugin. It was installed from code provided by others ' +
                'and it is used as an extension.',
            pluginExplanation: `<p>Only platforms defined as a plugin can be added to the system.
                You need to create a Git repository accessible by this server, optionally providing
                all authentication details.</p>
                <p>Plugins may contain malicious code that may damage the system, use resources for illicit purposes
                 or steal important information. <strong> Make sure you only import plugins from trusted sources </strong>. 
                This action may take minutes to finish.
                </p>
                <p>For more details about the required code and steps to define a plugin, please visit: 
                <a href="https://github.com/dccspeed/demo-plugin">https://github.com/dccspeed/demo-plugin</a>.</p>
            `,
            subset: 'Operations subset | Operations subsets',
        },
        privacy: {
            anonymizationTechnique: 'Anonymization technique',
            privacyType: 'Privacy type',
            hierarchy: 'Hierarchy (only if anonymization type = GENERALIZATION)',
            attributePrivacyGroup: 'Attribute privacy group'
        },

        property: {
            alias: 'Alias',
            attribute: 'Attribute',
            availableAttribute: 'Available attribute | Available attributes',
            clickToMove: 'Click an item to move it between lists',
            copyAttributeName:
                'Double click to copy and paste attribute name to edit box',
            editValue: 'Edit value...',
            function: 'Function',
            help: 'Help',
            informAttributeName: 'Not in the list? Inform a name',
            noExpressions: '0 Expression defined',
            taskName: 'Task name (optional)',
            expression: {
                availableAttribute: 'Available attribute | Available attributes',
                alias: 'New attribute name (alias)',
                explanation:
                    'Add one or more expresssions. New attributes will be created from the expressions informed here and you need to inform a name (alias) for them.',
                tip: `To use an attribute, just inform its name. For string constants, delimit them with quotes (single or double).
                Examples: <code>substring(name, instr(name, " "))</code>.`,
                title: 'Expression',
                validExpressions: `Valid expressions include math expressions
                (e.g. <strong><code>attr * 10 - 4 </code></strong>) and function calls
                (e.g. <strong><code>split(attr, ' ') </code></strong>). For more informations,
                see Lemonade Reference Guide or Apache Spark SQL functions. `
            },
            queryBuilder: {
                explanation:
                    'Write a SQL compatible Query. The supported syntax depend on the choosen platform, but in simple queries work in all cases. See documentation for more information.',
                title: 'SQL query command'
            },
            selectedAttribute: 'Selected attribute | Selected attributes'
        },
        profile: {
            alsoChangePassword: 'Also change my password',
            updated: 'Profile updated'
        },
        home: {
            aPlatformForDataScience: 'A platform for data science',
            learnMore: 'Learn more',
            recentlyUpdated: 'Recently updated',
            welcome: `Welcome to Lemonade.
            Lemonade (Live Exploration and Mining Of Non-trivial Amount of Data from Everywhere) is a visual platform for distributed computing, aimed to enable implementation, experimentation, test and deploying of data processing and machine learning applications. It provides a higher level of abstractions, called operations, to users build processing workflows using a graphical web interface. By using high performance and scalable technologies, such as COMPSs, Ophidia and Spark, Lemonade can process very large amount of data, hiding all backend complexity from the users and allowing them to focus mainly in the construction of the solution.
            Lemonade is implemented as an open-source tool and is under development as a product of EUBra-BIGSEA project.`
        },
        visualization: {
            lowerQuartile: 'Lower quartile',
            maximum: 'Maximum',
            median: 'Median',
            minimum: 'Minimum',
            ofEntry: 'of visible area',
            ofParent: 'of parent area',
            outlier: 'Outlier | Outliers',
            tryRefresh:
                'Try refresh the page, visualization may still be generating.',
            upperQuartile: 'Upper quartile'
        },
        workflow: {
            asImage: 'As a image (a download window will appear)',
            asTemplate: 'As a template workflow',
            copyOf: 'Copy of',
            copySavedWithSuccess: 'Copy saved with success!',
            execute: 'Execute workflow',
            errorNoCluster: 'Unable to execute workflow: There is not cluster available. Contact the administrator.',
            forPlatform: 'For processing platform',
            fromTemplate: 'From template',
            fromUserTemplate: 'From template created by users',
            imageGeneratedAt: 'Image generated at',
            jobName: 'Job name',
            newName:
                'New name (a copy of the workflow will be created, but not loaded)',
            noTasks: 'No task was added to the workflow. Use above option "Add operation" to start building the workflow.',
            preferredCluster: 'Preferred cluster for execution',
            publishingEnabled: 'Enable workflow to be published',
            publishingEnabledExplanation: 'Allows workflow to be published to users.',
            publishingSelect: 'Select properties that may be changed by users for published workflows.',
            publishingStatus: 'Publishing status',
            publisingStatusEditing: 'Editing - Not available to users',
            publisingStatusPublished: 'Published - Available to users',
            required:
                'Please, complete the required information for the execution of the workflow',
            restoreHistory: 'Do you really want to restore this workflow version?',
            versionRestored:
                'Version {version} restored with success.',
			setImage: 'Set workflow\'s image',
            useAsTemplate: 'This workflow is a template',
            useAsTemplateExplanation:
                'You will be able to create a new workflow from it. When adding a new workflow, choose the option  "From template".',

            useAsSystemTemplate: 'This workflow is a system template',
            useAsSystemTemplateExplanation:
                'Anyone in the system will be able to create a new workflow from it. When adding a new workflow, choose the option  "From template".',
            usingDisabledOperation: 'Task is using a disabled operation in Lemonade',
            validationExplanation:
                'There is an error in the workflow. The execution may not succeed. | There are errors in the workflow. The execution may not succeed.',
            variables: 'Variable | Variables',
        },
        variables: {
            addOrEdit: 'Add one or more items <br /> or click one of them at the right side to edit it.',
            attribute: 'Attribute',
            associateTo: 'Associate to variable',
            associateToLookup: 'Associate to lookup table',
            defaultValue: 'Default value',
            description: 'Description',
            help: 'Help',
            id: 'Identifier',
            index: 'Display index',
            label: 'Label',
            multiplicity: 'Multiplicity',
            name: 'Name',
            names: {
                date: 'Current date',
                date_at_min: 'Current date at 00:00:00',
                date_at_max: 'Current date at 23:59:59',
                now: 'Current date and time',
                user_id: 'User id',
                user_login: 'User login',
                user_name: 'User full name',
                workflow_id: 'Wokflow id',
                workflow_name: 'Workflow name',
            },
            parameter: 'Parameter | Parameters',
            operator: 'Operator | Operators',
            suggestedWidget: 'Suggested widget',
            textAfter: 'Text after field (supports Markdown)',
            textBefore: 'Text before field (supports Markdown)',
            text: 'Text|Texto',
            type: 'Type',
            values: 'Value | Values',
            operators: {
                bt: 'Between',
                eq: 'Equal (=)',
                lt: 'Less than (<)',
                gt: 'Greater than  (>)',
                le: 'Less or equal (<=)',
                ge: 'Greater or equal (>=)',
                ne: 'Different (/=)',
                'in': 'In list (∈)',
                ni: 'Not in list (∉)',
                user: 'Chosen by user',
            }

        },
        widgets: {
            checkbox: 'Check box',
            date: 'Date picker',
            decimal: 'Decimal number',
            dropdown: 'Drop down',
            integer: 'Number',
            lookup: 'Search from list of values',
            text: 'Text input',
            textarea: 'Long text input',
            join: {
                allAttributesWithPrefix: 'All attributes with prefix',
                conditions: 'Join condition(s)',
                nameCollision: 'Inputs have attributes with same name. This may cause problems if you do not use a prefix or rename them.',
                noAttributes: 'No attributes',
                noCondition: 'No condition specified. Press button below to add a new one.',
                selectAttributes: 'Select attributes',
                type: 'Join type',
            },
            expressionEditor:{
                atPosition: 'at position',
                expected: 'Expected',
                expectedColon: 'Expected :',
                expectedExpression: 'Expected expression',
                expectedExpressionAfter: 'Expected expression after',
                expectedExponent: 'Expected exponent',
                variableNamesWithNumber: 'Variable names cannot start with a number',
                unexpected: 'Unexpected',
                unexpectedComma: 'Unexpected comma',
                unexpectedPeriod: 'Unexpected period',
                unexpectedToken: 'Unexpected token',
                unexpectedQuote: 'Unexpected "',
                unclosedQuoteAfter: 'Unclosed quote after',
                unclosedBrace: 'Unclosed [',
                unclosedParenthesis: 'Unclosed (',
                unsupportedCompounded: 'Expressão não-suportada',
            }
        },
        permissions: {
            MANAGE: 'Manage',
            READ: 'Read',
            WRITE: 'Write',
            descriptions: {
                MANAGE: 'Allows all actions over the item',
                READ: 'Allows to read the item',
                WRITE: 'Allows to change or remove the item',
            }
        },
        storage: {
            address1: 'Main URL',
            address2: 'Secondary URL',
            extraParameters: 'Extra parameters',
        },


    }
};
